import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const accentColors = {
  blue: { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-600', icon: 'text-blue-400' },
  green: { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-600', icon: 'text-green-400' },
  amber: { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-600', icon: 'text-amber-400' },
  rose: { bg: 'bg-rose-50', border: 'border-rose-200', text: 'text-rose-600', icon: 'text-rose-400' },
};

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${API}/testimonials`);
        if (res.data.length > 0) {
          setTestimonials(res.data);
        }
      } catch (error) {
        console.error('Erreur chargement temoignages:', error);
      }
    };
    fetchTestimonials();
  }, []);

  useEffect(() => {
    if (testimonials.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  if (testimonials.length === 0) return null;

  const getVisible = () => {
    if (testimonials.length <= 3) return testimonials;
    const arr = [];
    for (let i = 0; i < 3; i++) {
      arr.push(testimonials[(current + i) % testimonials.length]);
    }
    return arr;
  };

  return (
    <section className="py-12 bg-gradient-to-b from-white to-gray-50" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1E3A5F] mb-3">
            Ce qu'ils disent de nous
          </h2>
          <p className="text-gray-500 text-base">
            Des voyageurs nous font confiance depuis 1997
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {getVisible().map((t, index) => {
            const colors = accentColors[t.accent] || accentColors.blue;
            return (
              <div
                key={t.id || index}
                data-testid={`testimonial-${t.id || index}`}
                className={`${colors.bg} border ${colors.border} rounded-xl p-6 transition-all duration-500 hover:shadow-md`}
              >
                <div className={`${colors.icon} mb-4`}>
                  <svg className="w-8 h-8 opacity-60" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                  </svg>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 italic">
                  "{t.quote}"
                </p>
                <div className="border-t border-gray-200 pt-3 mt-auto">
                  <p className={`${colors.text} font-bold text-sm`}>{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.trip} — {t.date}</p>
                </div>
              </div>
            );
          })}
        </div>

        {testimonials.length > 3 && (
          <div className="flex justify-center mt-6 gap-2" data-testid="testimonial-dots">
            {Array.from({ length: Math.ceil(testimonials.length / 3) }).map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i * 3)}
                aria-label={`Avis page ${i + 1}`}
                className="w-10 h-10 flex items-center justify-center"
              >
                <span className={`block w-2.5 h-2.5 rounded-full transition-all ${
                  Math.floor(current / 3) === i ? 'bg-[#5BC5D4] scale-125' : 'bg-gray-300 hover:bg-gray-400'
                }`} />
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
